import type { Prototype } from "../prototype-types";

export const mirandaFittsPrototypes: Prototype[] = [
  {
    id: "mf-cursor-skill-maze-test",
    name: "Brand Order Detail - Packing Slip Printing",
    path: "/mf/cursor-skill-maze-test",
    description:
      "UX iteration on brand order detail page focused on packing slip printing experience. Maze URL tracking enabled.",
    owner: "Miranda Fitts",
    createdAt: "2026-06-11",
    lastUpdated: "2026-06-11",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/be1f291a8f3bab7c90e81f2ba6a3542d0cbd3249be6c9f4edf78ef3e3215e1c3.png",
  },
];
